import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { addDays, fmt, mondayOf, weekNumber, toISO } from "@/lib/dates";

export const WeekPicker = ({ monday, onChange }) => {
  const isCurrent = toISO(monday) === toISO(mondayOf());
  return (
    <div className="flex items-center gap-2" data-testid="week-picker">
      <Button variant="outline" size="icon" onClick={() => onChange(addDays(monday, -7))} data-testid="week-prev-button" aria-label="Vorige week">
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <div className="min-w-[170px] text-center">
        <p className="text-xs font-semibold uppercase tracking-wider text-slate-500" data-testid="week-number">
          Week {weekNumber(monday)}
        </p>
        <p className="text-sm font-semibold text-slate-800" data-testid="week-range">
          {fmt(monday, "d MMM")} – {fmt(addDays(monday, 6), "d MMM yyyy")}
        </p>
      </div>
      <Button variant="outline" size="icon" onClick={() => onChange(addDays(monday, 7))} data-testid="week-next-button" aria-label="Volgende week">
        <ChevronRight className="h-4 w-4" />
      </Button>
      {!isCurrent && (
        <Button variant="ghost" size="sm" onClick={() => onChange(mondayOf())} data-testid="week-today-button">
          Deze week
        </Button>
      )}
    </div>
  );
};
